<template>
  <div>
    <h3 class="mb-3">{{ body.제목 }}</h3>
    <p class="mb-6" style="font-size: 18px;">
      <span style="font-weight: 500">시험결과 : </span>
      <span>{{result.successCount}}문항/{{result.successCount + result.failCount}}문항</span>
    </p>
    <div class="px-4 overflow-y-auto">
      <div v-for="(문제, index) in body.questions" :key="`문제_${index}`" class="mb-2">
        <div>
          <span style="font-size: 1.2rem; font-weight: 500; word-break: break-all; white-space: normal;" v-html="`Q${index + 1}. ${문제.title}`"></span>
          <span v-if="getSuccess(index)" class="ml-2 py-1 px-2" style="color: #fff; background-color: #28C76F; border-radius: 4px;">정답</span>
          <span v-else class="ml-2 py-1 px-2" style="color: #fff; background-color: #EA5455; border-radius: 4px;">오답</span>
        </div>
        <div class="p-2">
          <!-- 정답이 한 개인 경우 radio group -->
          <div v-if="isRadioQuestion(문제)" class="mb-2 py-2">
            <div v-for="(항목, 항목Index) in 문제.options" :key="`항목_${항목Index}`" class="mb-2 flex items-center gap-2">
              <vs-radio
                class="radio"
                disabled
                :color="getOptionsColor(index, 항목Index)"
                :style="{color: `#${getOptionsColor(index, 항목Index)}`}"
                :value="!!getOptionsColor(index, 항목Index)"
                :vs-value="항목Index+1">{{항목.label}}</vs-radio>

              <svg v-if="getOptionsColor(index, 항목Index) === '28C76F'" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 17.5C13.4183 17.5 17 13.9183 17 9.5C17 5.08172 13.4183 1.5 9 1.5C4.58172 1.5 1 5.08172 1 9.5C1 13.9183 4.58172 17.5 9 17.5Z" fill="#CAF9DF"/>
                <path d="M13.6436 6.45116C13.5413 6.35414 13.4039 6.2998 13.2607 6.2998C13.1175 6.2998 12.98 6.35414 12.8778 6.45116L7.95419 11.323L5.98471 9.31073C5.93769 9.25003 5.87776 9.19982 5.80895 9.16351C5.74013 9.12719 5.66408 9.1056 5.5859 9.10022C5.50772 9.09484 5.42921 9.10579 5.35578 9.13232C5.28235 9.15884 5.21567 9.20036 5.16024 9.254C5.10482 9.30765 5.06197 9.3722 5.03456 9.44328C5.00716 9.51435 4.99582 9.59029 5.00137 9.66597C5.00693 9.74164 5.02924 9.81529 5.06675 9.8819C5.10427 9.94852 5.15617 10.0066 5.21888 10.0521L7.6259 12.488C7.6259 12.5939 7.84478 12.6998 7.95419 12.6998C8.03912 12.6998 8.12285 12.6807 8.19881 12.6439C8.27477 12.6071 8.34085 12.5538 8.39181 12.488L13.6436 7.19254C13.7438 7.09355 13.8 6.96046 13.8 6.82185C13.8 6.68324 13.7438 6.55015 13.6436 6.45116Z" fill="#28C76F"/>
              </svg>

              <svg v-if="getOptionsColor(index, 항목Index) === 'EA5455'" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 17.5C13.4183 17.5 17 13.9183 17 9.5C17 5.08172 13.4183 1.5 9 1.5C4.58172 1.5 1 5.08172 1 9.5C1 13.9183 4.58172 17.5 9 17.5Z" fill="#FFDADA"/>
                <path d="M9.00391 11.9004C9.44354 11.9004 9.7998 12.2584 9.7998 12.7002C9.7997 13.1419 9.44347 13.5 9.00391 13.5H8.99609C8.55658 13.4999 8.2003 13.1419 8.2002 12.7002C8.2002 12.2584 8.55652 11.9005 8.99609 11.9004H9.00391ZM9 5.5C9.44176 5.5 9.7997 5.85807 9.7998 6.2998V9.5C9.7998 9.94183 9.44183 10.2998 9 10.2998C8.55826 10.2997 8.2002 9.94176 8.2002 9.5V6.2998C8.2003 5.85813 8.55833 5.50011 9 5.5Z" fill="#EA5455"/>
              </svg>

            </div>
          </div>

          <!-- 정답이 두 개이상인 경우 checkbox-->
          <div v-else class="py-2">
            <div v-for="(항목, 항목Index) in 문제.options" :key="`항목_${항목Index}`" class="mb-2 flex items-center gap-2">
              <vs-checkbox class="checkbox m-0"
                           disabled
                           :color="getOptionsColor(index, 항목Index)"
                           :style="{color: `#${getOptionsColor(index, 항목Index)}`}"
                           :value="!!getOptionsColor(index, 항목Index)"
                           :vs-value="항목Index+1">{{항목.label}}</vs-checkbox>

              <svg v-if="getOptionsColor(index, 항목Index) === '28C76F'" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 17.5C13.4183 17.5 17 13.9183 17 9.5C17 5.08172 13.4183 1.5 9 1.5C4.58172 1.5 1 5.08172 1 9.5C1 13.9183 4.58172 17.5 9 17.5Z" fill="#CAF9DF"/>
                <path d="M13.6436 6.45116C13.5413 6.35414 13.4039 6.2998 13.2607 6.2998C13.1175 6.2998 12.98 6.35414 12.8778 6.45116L7.95419 11.323L5.98471 9.31073C5.93769 9.25003 5.87776 9.19982 5.80895 9.16351C5.74013 9.12719 5.66408 9.1056 5.5859 9.10022C5.50772 9.09484 5.42921 9.10579 5.35578 9.13232C5.28235 9.15884 5.21567 9.20036 5.16024 9.254C5.10482 9.30765 5.06197 9.3722 5.03456 9.44328C5.00716 9.51435 4.99582 9.59029 5.00137 9.66597C5.00693 9.74164 5.02924 9.81529 5.06675 9.8819C5.10427 9.94852 5.15617 10.0066 5.21888 10.0521L7.6259 12.488C7.6259 12.5939 7.84478 12.6998 7.95419 12.6998C8.03912 12.6998 8.12285 12.6807 8.19881 12.6439C8.27477 12.6071 8.34085 12.5538 8.39181 12.488L13.6436 7.19254C13.7438 7.09355 13.8 6.96046 13.8 6.82185C13.8 6.68324 13.7438 6.55015 13.6436 6.45116Z" fill="#28C76F"/>
              </svg>

              <svg v-if="getOptionsColor(index, 항목Index) === 'EA5455'" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 17.5C13.4183 17.5 17 13.9183 17 9.5C17 5.08172 13.4183 1.5 9 1.5C4.58172 1.5 1 5.08172 1 9.5C1 13.9183 4.58172 17.5 9 17.5Z" fill="#FFDADA"/>
                <path d="M9.00391 11.9004C9.44354 11.9004 9.7998 12.2584 9.7998 12.7002C9.7997 13.1419 9.44347 13.5 9.00391 13.5H8.99609C8.55658 13.4999 8.2003 13.1419 8.2002 12.7002C8.2002 12.2584 8.55652 11.9005 8.99609 11.9004H9.00391ZM9 5.5C9.44176 5.5 9.7997 5.85807 9.7998 6.2998V9.5C9.7998 9.94183 9.44183 10.2998 9 10.2998C8.55826 10.2997 8.2002 9.94176 8.2002 9.5V6.2998C8.2003 5.85813 8.55833 5.50011 9 5.5Z" fill="#EA5455"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2 flex justify-center gap-2">
      <vs-button color="secondary" @click="$emit('re-questions')">재응시</vs-button>
      <vs-button color="#AEB1B6" @click="$emit('close')">닫기</vs-button>
    </div>
  </div>
</template>

<script>
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  name: 'Review',
  components: { RadioGroup },
  props: {
    data: Object,
  },
  computed: {
    body () {
      if (this.data) {
        return this.data.body || {};
      }
      return {};
    },
    정답 () {
      const 정답 = [];
      if (this.data) {
        this.body.questions.map((문제, index) => {
          const check = [];
          문제.options.map((항목, index) => {
            if (항목.answer === true) {
              check.push(index + 1);
            }
          });
          if (check.length > 1) {
            정답.push(check);
          } else {
            정답.push(check[0]);
          }
        });
      }
      return 정답;
    },
    submit() {
      if (this.data) {
        const contents = JSON.parse(this.data.post_content);
        const body = contents.body || {};
        return body.submit;
      }
      return [];
    },
    result() {
      let result = {
        successCount: 0,
        failCount: 0,
      }
      if (this.data) {
        const contents = JSON.parse(this.data.post_content);
        const body = contents.body || {};
        const submit = body.submit;
        return this.getTotalResult(submit);
      }
      return result;
    }
  },
  data() {
    return {
    };
  },
  methods: {
    load() {
      if (this.data) {
        this.setSubmit();
      }
    },
    isRadioQuestion(문제) {
      let count = 0;
      for (const 항목 of 문제.options) {
        if (항목.answer === true) {
          count++;
        }
      }
      return count === 1;
    },
    sortInnerArrays(arr) {
      return arr.map(item => {
        // 배열인 경우 정렬
        if (Array.isArray(item)) {
          return [...item].sort((a, b) => a - b);
        }
        return item; // 배열이 아니면 그대로 반환
      });
    },

    getTotalResult(submit) {
      let success = 0;
      let fail = 0;
      for (const [문제Index, 문제] of this.body.questions.entries()) {
        const 정답 = this.정답[문제Index];
        const 응답 = submit[문제Index];
        // 정답이 배열인 경우
        if (Array.isArray(정답)) {
          if (Array.isArray(응답) && JSON.stringify(정답.sort()) === JSON.stringify(응답.sort())) {
            success++;
          } else {
            fail++;
          }
        } else {
          // 정답이 단일 값인 경우
          if (정답 === 응답) {
            success++;
          } else {
            fail++;
          }
        }
      }
      const passed = success >= this.body.passCount;
      return {
        passed,
        successCount: success,
        failCount: fail
      }
    },

    getSuccess(index) {
      const 정답 = this.정답[index];
      const 응답 = this.submit[index];
      // 정답이 배열인 경우
      if (Array.isArray(정답)) {
        return Array.isArray(응답) && JSON.stringify(정답.sort()) === JSON.stringify(응답.sort());
      } else {
        // 정답이 단일 값인 경우
        return 정답 === 응답;
      }
    },

    getOptionsColor(iIndex, oIndex) {
      const 정답 = this.정답[iIndex];

      // 정답이 한 개인 경우
      if (typeof 정답 === 'number') {
        if (정답 === oIndex+1) {
          return '28C76F'; // 기본 색상
        } else if (this.submit[iIndex] && this.submit[iIndex] === oIndex + 1) {
          return 'EA5455'; // 오답 색상
        } else {
          return undefined; // 선택되지 않은 경우
        }
      }

      // 정답이 두 개 이상인 경우
      else if (Array.isArray(정답)) {
        if (정답.includes(oIndex + 1)) {
          return '28C76F'; // 기본 색상
        } else if (this.submit[iIndex] && this.submit[iIndex].includes(oIndex + 1)) {
          return 'EA5455'; // 오답 색상
        } else {
          return undefined; // 선택되지 않은 경우
        }
      }
      return undefined;
    }
  },
  mounted() {
  }
};
</script>

<style scoped lang="scss">
.radio::v-deep {
  .vs-radio--label {
    min-width: 12px;
  }
  .vs-radio--input:disabled+.vs-radio {
    opacity: 1;
    .vs-radio--borde {
      background: transparent;
    }
  }
  &.vs-radio-28C76F .vs-radio{
    background: #28C76F;
    .vs-radio--borde {
      border:none !important;
      background: transparent;
    }
    .vs-radio--circle {
      transform: scale(0.375);
      background: #fff;
      opacity: 1;
    }
  }
  &.vs-radio-EA5455 .vs-radio{
    background: #EA5455;
    .vs-radio--borde {
      border:none !important;
      background: transparent;
    }
    .vs-radio--circle {
      transform: scale(0.375);
      background: #fff;
      opacity: 1;
    }
  }
}
.checkbox::v-deep {
  .vs-checkbox--input:disabled+.vs-checkbox {
    opacity: 1;
  }
  &.vs-checkbox-28C76F .vs-checkbox{
    background: #28C76F;
  }
  &.vs-checkbox-EA5455 .vs-checkbox{
    background: #EA5455;
  }
}
</style>
